import VueGtagPlugin from 'vue-gtag';

const isDev = process.env.VUE_APP_ENV === 'development';

const params = {};

// Filters localhost data and enables debug mode to test in localhost
if (isDev) {
  params.debug_mode = true;
  params.traffic_type = 'internal';
}

export const gtagConfig = {
  config: {
    id: process.env.VUE_APP_G_ANALYTICS_ID,
    params,
  },
};

export const gtagPlugin = VueGtagPlugin;
